<mat-toolbar class="matero-toolbar">
  <button
    mat-icon-button
    class="matero-toolbar-button"
    *ngIf="(!environment.collapsibleSidebar || isMobile) && environment.displaySidebar"
    (click)="toggleSidenav.emit()"
  >
    <mat-icon>menu</mat-icon>
  </button>

  <span class="p-l-16 flex-1">Laboratory Quality Assurance</span>

  <app-translate *ngIf="environment.translateText"></app-translate>

  <button *ngIf="environment.showChatbot"
          mat-icon-button class="matero-toolbar-button"
          (click)="toggleChatbotNotice.emit()">
    <mat-icon>chat</mat-icon>
  </button>

  <div class="flex flex-row gap-2">

    <div class="flex items-center justify-start m-r-8"
      [matMenuTriggerFor]="userMenu">
      <span>{{userName}}</span>
    </div>

    <mat-menu #userMenu="matMenu">

      <button mat-menu-item class="matero-toolbar-button" aria-label="View Profile" matTooltip="View Profile"
        matTooltipPosition="below" routerLink='/profile' [matTooltipShowDelay]="750">
        <span class="p-r-8">View Profile</span>
        <mat-icon class="light-theme-icon">account_circle</mat-icon>
      </button>

      <button mat-menu-item *ngIf="environment.showThemeToggle && sharedService.darkMode" class="matero-toolbar-button"
        (click)="toggleTheme()" aria-label="Toggle Theme" matTooltip="Select Light Theme" matTooltipPosition="below"
        [matTooltipShowDelay]="750">
        <span class="p-r-8">Toggle Theme</span>
        <mat-icon class="light-theme-icon">brightness_7</mat-icon>
      </button>

      <button mat-menu-item *ngIf="environment.showThemeToggle && !sharedService.darkMode" class="matero-toolbar-button"
        (click)="toggleTheme()" aria-label="Toggle Theme" matTooltip="Select Dark Theme" matTooltipPosition="below"
        [matTooltipShowDelay]="750">
        <span class="p-r-8">Toggle Theme</span>
        <mat-icon class="dark-theme-icon">brightness_3</mat-icon>
      </button>

    </mat-menu>
  </div>

</mat-toolbar>
